import companyFrag from "./Company";
import conditionFrag from "./Condition";
import consignmentPurchaseFrag from "./ConsignmentPurchase";
import editionFrag from "./Edition";
import itemFrag from "./Item";
import offerFrag from "./Offer";
import Status from "./Status";
import valueFrag from "./Value";
import warehouseItemFrag from "./WarehouseItem";
import warehouseMove from "./WarehouseMove";

const Instance = ({
  arrApplicable = false,
  artworkId = false,
  articheckUrl = false,
  artistNames = false,
  artistRef = false,
  artsy = false,
  bondType = false,
  certificate = false,
  certificateSent = false,
  channelEcommerce = false,
  channelPresentation = false,
  company = false,
  condition = false,
  createdAt = false,
  currentWarehouseMove = false,
  description = false,
  droitdesuite = false,
  edition = false,
  editionNumber = false,
  editionNumberFormatted = false,
  fabricated = false,
  fabricatedDate = false,
  forSale = false,
  framed = false,
  ipad = false,
  isBond = false,
  isGuaranteed = false,
  isOnLoan = false,
  isSecondaryMarket = false,
  locationHistory = false,
  market = false,
  notes = false,
  parentOnline = false,
  ref = false,
  reference = false,
  returns = false,
  returnsDirector = false,
  salePrice = false,
  salesStrategy = false,
  status = false,
  statusHistory = false,
  statusId = false,
  statusUndo = false,
  unpackedWeight = false,
  updatedAt = false,
  value = false,
  location = false,
  volume = false,
  typeId = volume?.typeId || 1,
  weight = false,
  warehouseItem = false,
  offer = false,
  item = false,
  consignmentPurchase = false,
} = {}) => `
  id
  name
  ${arrApplicable ? "arrApplicable" : ""}
  ${artworkId ? "artworkId" : ""}
  ${articheckUrl ? "articheckUrl" : ""}
  ${artistNames ? "artistNames" : ""}
  ${artistRef ? "artistRef" : ""}
  ${artsy ? "artsy" : ""}
  ${bondType ? "bondType { type, company, description }" : ""}
  ${certificate ? "certificate" : ""}
  ${certificateSent ? "certificateSent" : ""}
  ${channelEcommerce ? "channelEcommerce" : ""}
  ${channelPresentation ? "channelPresentation" : ""}
  ${
    company
      ? `company {
      ${companyFrag({
        consignmentTerms: false,
        loanTerms: false,
        ...(typeof company === "object" ? company : {}),
      })}
    }`
      : ""
  }
  ${
    condition
      ? `condition {
      ${conditionFrag(condition)}
    }`
      : ""
  }
  ${
    consignmentPurchase
      ? `consignmentPurchase {
      ${consignmentPurchaseFrag}
    }`
      : ""
  }  
  ${createdAt ? "createdAt" : ""}
  ${description ? "description" : ""}
  ${droitdesuite ? "droitdesuite" : ""}
  ${
    edition
      ? `edition {
      ${editionFrag(edition)}
    }`
      : ""
  }
  ${editionNumber ? "editionNumber" : ""}
  ${editionNumberFormatted ? "editionNumberFormatted" : ""}
  ${fabricated ? "fabricated" : ""}
  ${fabricatedDate ? "fabricatedDate" : ""}
  ${forSale ? "forSale" : ""}
  ${framed ? "framed" : ""}
  ${ipad ? "ipad" : ""}
  ${isBond ? "isBond" : ""}
  ${isGuaranteed ? "isGuaranteed" : ""}
  ${isOnLoan ? "isOnLoan" : ""}
  ${isSecondaryMarket ? "isSecondaryMarket" : ""}
  ${
    currentWarehouseMove
      ? `currentWarehouseMove {
      ${warehouseMove(currentWarehouseMove)}
    }`
      : ""
  }
  ${locationHistory ? "locationHistory" : ""}
  ${market ? "market" : ""}
  ${notes ? "notes" : ""}
  ${parentOnline ? "parentOnline" : ""}
  ${ref ? "ref" : ""}
  ${reference ? "reference" : ""}
  ${returns ? "returns" : ""}
  ${returnsDirector ? "returnsDirector" : ""}
  ${
    status
      ? `status {
      ${Status}
    }`
      : ""
  }
  ${statusId ? "statusId" : ""}
  ${statusUndo ? "statusUndo" : ""}
  ${salePrice ? "salePrice" : ""}
  ${salesStrategy ? "salesStrategy" : ""}
  ${statusHistory ? "statusHistory" : ""}
  ${unpackedWeight ? "unpackedWeight" : ""}
  ${updatedAt ? "updatedAt" : ""}
  ${
    value
      ? `insuranceValue: value {
      ${valueFrag(value)}
    }`
      : ""
  }
  ${
    value
      ? `value {
      ${valueFrag(value)}
    }`
      : ""
  }
  ${weight ? `weight` : ""}
  ${volume ? `volume(typeId: ${typeId})` : ""}
  ${location ? `location` : ""}
  ${
    warehouseItem
      ? `warehouseItem {
      ${warehouseItemFrag(warehouseItem)}
    }`
      : ""
  }
  ${
    offer
      ? `offer {
      ${offerFrag(offer)}
    }`
      : ""
  }
  ${
    item
      ? `item {
      ${itemFrag(item)}
    }`
      : ""
  }
`;

export default Instance;
